import { render, staticRenderFns } from "./Seeds.vue?vue&type=template&id=16e5f887&scoped=true&"
import script from "./Seeds.vue?vue&type=script&lang=js&"
export * from "./Seeds.vue?vue&type=script&lang=js&"
import style0 from "./Seeds.vue?vue&type=style&index=0&id=16e5f887&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5f887",
  null
  
)

export default component.exports